import React, { Component, Fragment } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import DeleteScream from "./DeleteScream";
import ScreamDialog from "./ScreamDialog";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

//MUI stuff
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";

// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import MoreVertIcon from "@material-ui/icons/MoreVert";
// import TextField from "@material-ui/core/TextField";
// import Button from "@material-ui/core/Button";
// import { makeStyles } from "@material-ui/core/styles";
// import days from "dayjs";
// import clsx from "clsx";
// import Collapse from "@material-ui/core/Collapse";
// import IconButton from "@material-ui/core/IconButton";

import AddCommentIcon from "@material-ui/icons/AddComment";

// Redux
import { connect } from "react-redux";

// import MyButton from "../../util/MyButton";
import LikeButton from "./LikeButton";

const styles = {
  root: {
    width: "100%",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    // transition: theme.transitions.create("transform", {
    //   duration: theme.transitions.duration.shortest,
    // }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  container: {
    // margin: "80px auto 0 auto",
    marginTop: "40px",
    maxWidth: "1000px",
  },
  text: {
    width: "100%",
    margin: "0px",
  },
  button: {
    paddingLeft: "0",
    paddingRight: "0",
    paddingTop: "16px",
    paddingBottom: "16px",
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
    width: "100%",
  },
  textfield: {
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
  },
  subbutton: {
    width: "100%",
  },
};

class Scream extends Component {
  render() {
    dayjs.extend(relativeTime);

    const {
      classes,
      scream: {
        body,
        createdAt,
        userHandle,
        userImage,
        firstName,
        lastName,
        collegeName,
        likeCount,
        commentCount,
        postImageUrl,
        screamId,
        key,
        what,
        fore,
        when,
        where,
      },
      user: {
        authenticated,
        credentials: { handle },
      },
    } = this.props;

    const deleteButton =
      authenticated && userHandle === handle ? (
        <DeleteScream screamId={screamId} />
      ) : null;

    // const classes = useStyles();

    // const handleExpandClick = () => {
    //   setExpanded(!expanded);
    // };
    // const [expanded, setExpanded] = React.useState(false);

    return (
      <div className={classes.container} key={key}>
        <Grid item sm={12} xs={12}>
          <Card>
            <CardHeader
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  <div>
                    <img
                      alt="Profile"
                      src={userImage}
                      height="100%"
                      width="100%"
                      objectFit="cover"
                    />
                  </div>
                </Avatar>
              }
              action={
                /*<IconButton aria-label="settings">*/
                /*</IconButton>*/
                <Fragment>{deleteButton}</Fragment>
              }
              title={
                <Typography
                  component={Link}
                  to={`/users/${userHandle}`}
                  color="secondary"
                >
                  {collegeName}.
                  <span style={{ color: "black" }}>
                    {firstName} {lastName}.
                  </span>
                  <span style={{ color: "blue" }}>{userHandle}</span>
                </Typography>
              }
              subheader={dayjs(createdAt).fromNow()}
            />

            <CardMedia
              className={classes.media}
              image={postImageUrl}
              title="Post"
              style={{ height: "200px", objectFit: "cover" }}
            />
            <CardContent>
              <Typography variant="body1" color="textSecondary" component="p">
                {body}
              </Typography>
              <Typography>What: {what}</Typography>
              <Typography>Which Year & Stream: {fore}</Typography>
              <Typography>When: {when}</Typography>
              <Typography>Where: {where}</Typography>
            </CardContent>
            <CardActions disableSpacing>
              {/* <IconButton aria-label="add to favorites"> */}
              <LikeButton screamId={screamId} />
              <Typography
                color="action"
                style={{ color: "#acb1a2", paddingRight: "12px" }}
              >
                {" "}
                {likeCount} Likes
              </Typography>
              {/* </IconButton> */}

              <AddCommentIcon
                color="action"
                className={classes.comment}
                style={{ paddingRight: "12px" }}
              ></AddCommentIcon>
              <Typography color="textSecondary">
                {commentCount} Comments
              </Typography>

              {/* <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              > 
                <ExpandMoreIcon />
              </IconButton> */}
            </CardActions>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              className={classes.root}
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              {/* <form  noValidate autoComplete="off"> */}
              {/* <Grid
                item
                xs={10}
                sm={10}
                md={10}
                lg={10}
                className={classes.text}
              >
                <TextField
                  style={{
                    borderTopRightRadius: "0px",
                    borderBottomRightRadius: "0px",
                  }}
                  fullWidth
                  id="outlined-basic"
                  label="Comment"
                  variant="outlined"
                />
              </Grid> */}
              {/* <Grid
                item
                xs={2}
                sm={2}
                md={2}
                lg={2}
                className={classes.subbutton}
              >
                <Button className={classes.button} variant="contained">
                  Send
                </Button>
              </Grid> */}
              <ScreamDialog
                screamId={screamId}
                userHandle={userHandle}
                firstName={firstName}
                lastName={lastName}
                openDialog={this.props.openDialog}
              />
              {/* </form> */}
            </Grid>
            {/* <Collapse  in={expanded}  timeout="auto" unmountOnExit>
              <CardContent>
                <Typography paragraph>What: Event Name</Typography>
                <Typography paragraph>
                  Which Year & Stream: Year and stream
                </Typography>
                <Typography paragraph>When: Date and Time</Typography>
                <Typography paragraph>Where: Venue/Site Link</Typography>
              </CardContent>
            </Collapse> */}
          </Card>
        </Grid>
      </div>
    );
  }
}

Scream.propTypes = {
  user: PropTypes.object.isRequired,
  scram: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  openDialog: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(withStyles(styles)(Scream));

// const useStyles = makeStyles((theme) => ({
//   root: {
//     width: "100%",
//   },
//   media: {
//     height: 0,
//     paddingTop: "56.25%", // 16:9
//   },
//   expand: {
//     transform: "rotate(0deg)",
//     marginLeft: "auto",
//     transition: theme.transitions.create("transform", {
//       duration: theme.transitions.duration.shortest,
//     }),
//   },
//   expandOpen: {
//     transform: "rotate(180deg)",
//   },
//   avatar: {
//     backgroundColor: red[500],
//   },
//   container: {
//     // margin: "80px auto 0 auto",
//     marginTop: "40px",
//     maxWidth: "1000px",
//   },
//   text: {
//     width: "100%",
//     margin: "0px",
//   },
//   button: {
//     paddingLeft: "0",
//     paddingRight: "0",
//     paddingTop: "16px",
//     paddingBottom: "16px",
//     borderTopLeftRadius: "0px",
//     borderBottomLeftRadius: "0px",
//     width: "100%",
//   },
//   textfield: {
//     borderTopRightRadius: "0px",
//     borderBottomRightRadius: "0px",
//   },
//   subbutton: {
//     width: "100%",
//   },
// }));
// export default function Scream(props) {
//   const classes = useStyles();
//   const [expanded, setExpanded] = React.useState(false);
//   const scream = {
//     body: props.scream.body,
//     createdAt: props.scream.createdAt,
//     userImage: props.scream.userImage,
//     userHandle: props.scream.userHandle,
//     firstName: props.scream.firstName,
//     lastName: props.scream.lastName,
//     collegeName: props.scream.collegeName,
//     likeCount: props.scream.likeCount,
//     commentCount: props.scream.commentCount,
//     postImageUrl: props.scream.postImageUrl,
//     key: props.scream.screamId,
//   };

//   const handleExpandClick = () => {
//     setExpanded(!expanded);
//   };

//   dayjs.extend(relativeTime);

//   return (
//     <div className={classes.container} key={scream.screamId}>
//       <Grid item sm={12} xs={12}>
//         <Card>
//           <CardHeader
//             avatar={
//               <Avatar aria-label="recipe" className={classes.avatar}>
//                 <div>
//                   <img
//                     alt="Profile"
//                     src={scream.userImage}
//                     height="100%"
//                     width="100%"
//                   />
//                 </div>
//               </Avatar>
//             }
//             action={
//               <IconButton aria-label="settings">
//                 <MoreVertIcon />
//               </IconButton>
//             }
//             title={
//               <Typography
//                 component={Link}
//                 to={`/users/${scream.userHandle}`}
//                 color="secondary"
//               >
//                 {scream.collegeName}.
//                 <span style={{ color: "black" }}>
//                   {scream.firstName} {scream.lastName}.
//                 </span>
//                 <span style={{ color: "blue" }}>{scream.userHandle}</span>
//               </Typography>
//             }
//             subheader={dayjs(scream.createdAt).fromNow()}
//           />

//           <CardMedia
//             className={classes.media}
//             image={scream.postImageUrl}
//             title="Post"
//             style={{ height: "200px", objectFit: "cover" }}
//           />
//           <CardContent>
//             <Typography variant="body1" color="textSecondary" component="p">
//               {scream.body}
//             </Typography>
//           </CardContent>
//           <CardActions disableSpacing>
//             <IconButton aria-label="add to favorites">
//               <FavoriteIcon />
//               <Typography>{scream.likeCount}</Typography>
//             </IconButton>

//             <AddCommentIcon
//               color="action"
//               className={classes.comment}
//             ></AddCommentIcon>
//             <Typography color="textSecondary">{scream.commentCount}</Typography>

//             <IconButton
//               className={clsx(classes.expand, {
//                 [classes.expandOpen]: expanded,
//               })}
//               onClick={handleExpandClick}
//               aria-expanded={expanded}
//               aria-label="show more"
//             >
//               <ExpandMoreIcon />
//             </IconButton>
//           </CardActions>
//           <Grid
//             container
//             direction="row"
//             justify="center"
//             alignItems="center"
//             className={classes.root}
//             item
//             xs={12}
//             sm={12}
//             md={12}
//             lg={12}
//           >
//             {/* <form  noValidate autoComplete="off"> */}
//             <Grid item xs={10} sm={10} md={10} lg={10} className={classes.text}>
//               <TextField
//                 style={{
//                   borderTopRightRadius: "0px",
//                   borderBottomRightRadius: "0px",
//                 }}
//                 fullWidth
//                 id="outlined-basic"
//                 label="Comment"
//                 variant="outlined"
//               />
//             </Grid>
//             <Grid
//               item
//               xs={2}
//               sm={2}
//               md={2}
//               lg={2}
//               className={classes.subbutton}
//             >
//               <Button className={classes.button} variant="contained">
//                 Send
//               </Button>
//             </Grid>
//             {/* </form> */}
//           </Grid>
//           <Collapse in={expanded} timeout="auto" unmountOnExit>
//             <CardContent>
//               <Typography paragraph>What: Event Name</Typography>
//               <Typography paragraph>
//                 Which Year & Stream: Year and stream
//               </Typography>
//               <Typography paragraph>When: Date and Time</Typography>
//               <Typography paragraph>Where: Venue/Site Link</Typography>
//             </CardContent>
//           </Collapse>
//         </Card>
//       </Grid>
//     </div>
//   );
// }
